import dayjs from "dayjs";
import {
  ColumnTitle,
  TableBody,
  TableColumn,
  TableContainer,
  TableHead,
  TableHeader,
  TableRowOrdemService,
  TableTitle,
} from "../../../../../../../CSSGlobal";
import { useState } from "react";
import { Checkbox } from "antd";

export function TabelaCorrelacionadas({ tarefasCorrelacionadas, formulario }) {
  const [titleTable, setTitleTable] = useState([
    {
      id: 1,
      titles: [
        {
          title: "Vencimento",
        },
        {
          title: "Obrigação",
        },
        {
          title: "Descrição",
        },
        {
          title: "Situação",
        },
        {
          title: "Emitir?",
        },
      ],
    },
  ]);
  const [isEmitirCorrelacionada, setIsEmitirCorrelacionada] = useState(true);

  return (
    <>
      <TableHeader>
        <TableHead>
          {titleTable[0].titles.map((item, index) => {
            return (
              <ColumnTitle key={index} id={index}>
                <TableTitle>
                  <strong
                    style={{
                      color: "#005a9e",
                      fontSize: 14,
                    }}
                  >
                    {item.title}
                  </strong>
                </TableTitle>
              </ColumnTitle>
            );
          })}
        </TableHead>
      </TableHeader>
      <TableContainer>
        <TableBody>
          {tarefasCorrelacionadas.map((tarefa, index) => (
            <>
              <TableRowOrdemService key={index}>
                <TableColumn>
                  <span>
                    {dayjs(tarefa.dataVencimento).format("DD-MM-YYYY")}
                  </span>
                </TableColumn>
                <TableColumn>
                  <span>
                    {tarefa.obrigacao.id} - {tarefa.obrigacao.sigla}
                  </span>
                </TableColumn>
                <TableColumn>
                  <span>
                    {(formulario.situacao === "S"
                      ? "Sem Movimento"
                      : formulario.descricao) +
                      " - ref. " +
                      dayjs(formulario.mesRef).format("MM/YYYY") +
                      " em decorrência da obrigação " +
                      formulario.sigla +
                      (formulario.situacao === "S"
                        ? " - Sem Movimento"
                        : formulario.situacao)}
                  </span>
                </TableColumn>
                <TableColumn>
                  <span>{tarefa.obrigacao.situacao.nome}</span>
                </TableColumn>
                <TableColumn>
                  <Checkbox
                    checked={isEmitirCorrelacionada}
                    onChange={(e) =>
                      setIsEmitirCorrelacionada(e.target.checked)
                    }
                  ></Checkbox>
                </TableColumn>
              </TableRowOrdemService>
            </>
          ))}
        </TableBody>
      </TableContainer>
    </>
  );
}

export default TabelaCorrelacionadas;
